<template>
	<!-- 隐私协议 -->
	<div class="ql-editor">
		<div class="box-shadow pad-16 wid-100" v-html="content"></div>
	</div>
</template>
<script>
	import {
		getAgreement
	} from '@/api/personal/api.js';
	export default {
		data() {
			return {
				content: ''
			}

		},
		mounted() {
			this.getInit();
		},
		methods: {
			getInit() {
				getAgreement({
					type: 1
				}).then(res => {
					this.content = res.data.content;
					this.content = this.content.replace(/<img/g,
						'<img mode="widthFix" style="width: 98%"');
				})
			}
		}
	}
</script>


<style scoped>
	.box-shadow {
		box-shadow: 2px 2px 8px 0px rgba(195, 219, 255, 0.25);
		border-radius: 8px 8px 8px 8px;
	}

	.pad-16 {
		padding: 16px;
	}
</style>